// extracted by mini-css-extract-plugin
export default {"modal":"aL-z","modalOverlay":"bL-z","outfitHeading":"cL-z"};